import * as React from 'react'
import Text from '@eversports/klimt-primitives/Text'
import Button from '@eversports/klimt-primitives/Button'
import { useState } from 'react'

import { Localized } from '../../../../../localization/react'

import AllFavourites from './AllFavourites'

const ShowAllFavouriteVenues = () => {
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <>
      <Button
        variant="tertiary"
        sx={{ px: 6, py: 1, width: 'fit-content', border: '1px solid', borderColor: 'mediumgray', margin: '0 auto' }}
        onClick={handleClick}
      >
        <Text variant="small" sx={{ fontWeight: 'bold', textTransform: 'none', color: 'midnight' }}>
          <Localized id="user-profile-favourite-venues-show-all-button" />
        </Text>
      </Button>
      <AllFavourites isOpen={isOpen} onClose={handleClose} />
    </>
  )
}

export default ShowAllFavouriteVenues
